import React from 'react';
import { useDispatch } from 'react-redux';
import { openDailyCheckInRewardModal } from 'dispatcher/modalDispatcher';
import Image from 'next/image';
import mixpanel, { trackedEvents } from 'utils/mixpanel';
import { rewardOnboarding } from 'theme';

const DailyCheckInCard = () => {
  const dispatch = useDispatch();

  return (
    <div
      className="card bg-neutral-700 cursor-pointer"
      onClick={() => {
        dispatch(openDailyCheckInRewardModal());
        mixpanel.track(trackedEvents.RewardPrelaunchOnboarding, {
          param: 'rewards_banner_clicked',
        });
      }}
    >
      <div className="flex justify-between w-full items-center">
        <div className="flex flex-col gap-2">
          <p className="text-base font-bold text-white">
            <span role="img" aria-label="calendar">
              🗓
            </span>{' '}
            Check-in and get rewarded!
          </p>
          <p className="text-white">
            Redeem 200 credits when you check-in for 7 consecutive days
          </p>
        </div>
        <Image src={rewardOnboarding.coin} width={55} height={55} />
      </div>
    </div>
  );
};

export default DailyCheckInCard;
